import React, { memo, useRef, useEffect, } from "react";
import { css, cx } from "@emotion/css";
import { inputFormStyle } from "../../../styles";
const InputForm = ({ inputFormStyleFn, menuOpen, inputValue, changeInputValue, selectedOption, incrementFocusOptionMenuIndex, decrementFocusOptionMenuIndex, openMenu, closeMenu, }) => {
    const inputFormRef = useRef(null);
    const onChange = (e) => {
        changeInputValue(e.target.value);
    };
    const onKeyUp = ({ key }) => {
        switch (key) {
            case "Escape":
                return closeMenu();
            case "Enter":
                return selectedOption();
            case "ArrowDown":
                return incrementFocusOptionMenuIndex();
            case "ArrowUp":
                return decrementFocusOptionMenuIndex();
            default:
                if (!menuOpen) {
                    openMenu();
                }
        }
    };
    useEffect(() => {
        if (inputFormRef.current && menuOpen) {
            inputFormRef.current.focus();
        }
    }, [menuOpen]);
    return (React.createElement("input", { ref: inputFormRef, className: cx("react-auto-scroll-time-select__input-form", css(inputFormStyleFn ? inputFormStyleFn(inputFormStyle) : inputFormStyle)), type: "text", value: inputValue || "", maxLength: 5, onClick: () => {
            if (!menuOpen)
                openMenu();
        }, onFocus: () => {
            if (!menuOpen)
                openMenu();
        }, onBlur: () => {
            if (menuOpen)
                closeMenu();
        }, onChange: onChange, onKeyUp: onKeyUp }));
};
export default memo(InputForm);
